// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"PaginationBlock_contentWrapper__3gWgk","selectBlock":"PaginationBlock_selectBlock__3Mmbi","selectLabel":"PaginationBlock_selectLabel__156mj"};